import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class IntermodalService {
  WEIGHBRIDGE_BASE_PATH = '/weighbridges';
  LOADING_BASE_PATH = '/loadings';
  ON_LOADING_BASE_PATH = '/onloadings';
  LIFT_BASE_PATH = '/lifts';
  REHEATING_BASE_PATH = '/reheatings';
  EIR_BASE_PATH = '/eirs';
  BOL_BASE_PATH = '/bols';
  ENTRY_BASE_PATH = '/entries';
  TEMPLATE_BASE_PATH = '/templates';
  FLEET_BASE_PATH = '/fleets';
  VESSEL_BASE_PATH = '/vessels';
  CARGO_BASE_PATH = '/cargoes';
  DGD_BASE_PATH = '/dgds';

  constructor(private http: HttpService) {}

  // WEIGHBRIDGES
  getWeighbridges(params: object = {}): Observable<any> {
    return this.http.get(`${this.WEIGHBRIDGE_BASE_PATH}`, params);
  }

  getWeighbridgeById(id): Observable<any> {
    return this.http.get(`${this.WEIGHBRIDGE_BASE_PATH}/${id}`);
  }

  updateWeighbridgeById(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.WEIGHBRIDGE_BASE_PATH}/${id}`, body);
  }

  overrideWeighbridgeById(id, body: object = {}): Observable<any> {
    return this.http.post(`${this.WEIGHBRIDGE_BASE_PATH}/${id}/override`, body);
  }

  updateValidateWeighbridgeById(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.WEIGHBRIDGE_BASE_PATH}/${id}/validate`, body);
  }

  // LOADINGS
  getLoading(params: any): Observable<any> {
    return this.http.get(`${this.LOADING_BASE_PATH}`, params);
  }

  getLoadingById(id: string): Observable<any> {
    return this.http.get(`${this.LOADING_BASE_PATH}/${id}`);
  }

  updateLoadingById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.LOADING_BASE_PATH}/${id}`, body, {observe: 'response'});
  }

  overrideLoadingById(id: string, body: any): Observable<any> {
    return this.http.post(`${this.LOADING_BASE_PATH}/${id}/override`, body, {observe: 'response'});
  }

  updateValidateLoadingById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.LOADING_BASE_PATH}/${id}/validate`, body, {observe: 'response'});
  }

  // LOADINGS
  getOnLoading(params: any): Observable<any> {
    return this.http.get(`${this.ON_LOADING_BASE_PATH}`, params);
  }

  getOnLoadingById(id: string): Observable<any> {
    return this.http.get(`${this.ON_LOADING_BASE_PATH}/${id}`);
  }

  updateOnLoadingById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.ON_LOADING_BASE_PATH}/${id}`, body, {observe: 'response'});
  }

  overrideOnLoadingById(id: string, body: any): Observable<any> {
    return this.http.post(`${this.ON_LOADING_BASE_PATH}/${id}/override`, body, {observe: 'response'});
  }

  updateValidateOnLoadingById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.ON_LOADING_BASE_PATH}/${id}/validate`, body, {observe: 'response'});
  }

  // LIFTS
  getLifts(params: any): Observable<any> {
    return this.http.get(`${this.LIFT_BASE_PATH}`, params);
  }

  getLiftsById(id: string): Observable<any> {
    return this.http.get(`${this.LIFT_BASE_PATH}/${id}`);
  }

  updateLiftsById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.LIFT_BASE_PATH}/${id}`, body, {observe: 'response'});
  }

  overrideLiftsById(id: string, body: any): Observable<any> {
    return this.http.post(`${this.LIFT_BASE_PATH}/${id}/override`, body, {observe: 'response'});
  }

  updateValidateLiftsById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.LIFT_BASE_PATH}/${id}/validate`, body, {observe: 'response'});
  }

  // REHEATINGS
  getContainers(params: object = {}): Observable<any> {
    return this.http.get(`${this.REHEATING_BASE_PATH}`, params);
  }

  getContainerById(id): Observable<any> {
    return this.http.get(`${this.REHEATING_BASE_PATH}/${id}`);
  }

  updateContainerById(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.REHEATING_BASE_PATH}/${id}`, body);
  }

  overrideContainerById(id, body: object = {}): Observable<any> {
    return this.http.post(`${this.REHEATING_BASE_PATH}/${id}/override`, body);
  }

  // EIRS
  getEirs(params: object = {}): Observable<any> {
    return this.http.get(`${this.EIR_BASE_PATH}`, params);
  }

  getEirById(id): Observable<any> {
    return this.http.get(`${this.EIR_BASE_PATH}/${id}`);
  }

  updateEirById(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.EIR_BASE_PATH}/${id}`, body);
  }

  overrideEirById(id, body: object = {}): Observable<any> {
    return this.http.post(`${this.EIR_BASE_PATH}/${id}/override`, body);
  }

  // FLEETS
  getFleet(params: any): Observable<any> {
    return this.http.get(`${this.FLEET_BASE_PATH}`, params);
  }

  getFleetById(id: string): Observable<any> {
    return this.http.get(`${this.FLEET_BASE_PATH}/${id}`);
  }

  updateFleetById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.FLEET_BASE_PATH}/${id}`, body, {observe: 'response'});
  }

  // BOLS
  getBols(params: object = {}): Observable<any> {
    return this.http.get(`${this.BOL_BASE_PATH}`, params);
  }

  getBolById(id): Observable<any> {
    return this.http.get(`${this.BOL_BASE_PATH}/${id}`);
  }

  updateBolById(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.BOL_BASE_PATH}/${id}`, body);
  }

  overrideBolById(id, body: object = {}): Observable<any> {
    return this.http.post(`${this.BOL_BASE_PATH}/${id}/override`, body);
  }

  // ENTRY LIST
  getEntryList(scope, params: object = {}): Observable<any> {
    let path = this.ENTRY_BASE_PATH;
    if (scope === 'GATE_IN') {
      path = `${this.ENTRY_BASE_PATH}/type/0`;
    } else if (scope === 'GATE_OUT') {
      path = `${this.ENTRY_BASE_PATH}/type/1`;
    }
    return this.http.get(path, params);
  }

  getEntryById(id): Observable<any> {
    return this.http.get(`${this.ENTRY_BASE_PATH}/gate/${id}`);
  }

  updateEntryById(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.ENTRY_BASE_PATH}/${id}`, body);
  }
  updateValidateEntryById(eId, id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.ENTRY_BASE_PATH}/${eId}/entry_records/${id}/validate`, body);
  }

  getTemplateFormGateIn(): Observable<any> {
    return this.http.get(`${this.TEMPLATE_BASE_PATH}/3`);
  }

  getTemplateFormGateOut(): Observable<any> {
    return this.http.get(`${this.TEMPLATE_BASE_PATH}/7`);
  }

  addEntryForm(id, params): Observable<any> {
    return this.http.post(`${this.ENTRY_BASE_PATH}/${id}/gate`, params);
  }

  saveEntryForm(id, params): Observable<any> {
    return this.http.patch(`${this.ENTRY_BASE_PATH}/gate/${id}`, params);
  }

  overrideEntryForm(id, params): Observable<any> {
    return this.http.post(`${this.ENTRY_BASE_PATH}/${id}/override`, params);
  }

  getReferencesByEntryId(id): Observable<any> {
    return this.http.get(`${this.ENTRY_BASE_PATH}/${id}/references`);
  }

  getVessel(params?): Observable<any> {
    return this.http.get(`${this.VESSEL_BASE_PATH}`, params);
  }

  getVesselById(id: string): Observable<any> {
    return this.http.get(`${this.VESSEL_BASE_PATH}/${id}`);
  }

  updateVesselById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.VESSEL_BASE_PATH}/${id}`, body, {observe: 'response'});
  }

  overrideVesselById(id: string, body: any): Observable<any> {
    return this.http.post(`${this.VESSEL_BASE_PATH}/${id}/override`, body, {observe: 'response'});
  }

  updateValidateVesselById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.VESSEL_BASE_PATH}/${id}/validate`, body, {observe: 'response'});
  }

  getCargos(params?): Observable<any> {
    return this.http.get(`${this.CARGO_BASE_PATH}`, params);
  }

  getCargoById(id: string): Observable<any> {
    return this.http.get(`${this.CARGO_BASE_PATH}/${id}`);
  }

  updateCargoById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.CARGO_BASE_PATH}/${id}`, body, {observe: 'response'});
  }

  updateCargoValidateById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.CARGO_BASE_PATH}/${id}/validate`, body, {observe: 'response'});
  }

  overrideCargoById(id: string, body: any): Observable<any> {
    return this.http.post(`${this.CARGO_BASE_PATH}/${id}/override`, body, {observe: 'response'});
  }

  getDgds(params?): Observable<any> {
    return this.http.get(`${this.DGD_BASE_PATH}`, params);
  }

  getDgdById(id: string): Observable<any> {
    return this.http.get(`${this.DGD_BASE_PATH}/${id}`);
  }

  updateDgdById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.DGD_BASE_PATH}/${id}`, body, {observe: 'response'});
  }

  updateDgdValidateById(id: string, body: any): Observable<any> {
    return this.http.patch(`${this.DGD_BASE_PATH}/${id}/validate`, body, {observe: 'response'});
  }

  overrideDgdById(id: string, body: any): Observable<any> {
    return this.http.post(`${this.DGD_BASE_PATH}/${id}/override`, body, {observe: 'response'});
  }
}
